import React, { useState } from 'react'
import Autocomplete from './Organizations/Autocomplete'
import NewOrganizationModal from './Organizations/NewOrganizationModal'

const OrganizationDropdown = ({ organization, setOrganization }) => {
  const [orgQuery, setOrgQuery] = useState(
    organization.name && organization.location
      ? `${organization.name} - ${organization.location.city} ${organization.location.country}`
      : ''
  )
  const [defaultQuery, setDefaultQuery] = useState('')
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <NewOrganizationModal
        defaultQuery={defaultQuery}
        done={(query, organizationId) => {
          setOrgQuery(query)
          setOrganization((prev) => ({ ...prev, id: organizationId }))
        }}
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
      <Autocomplete
        width={8}
        label="Organization"
        placeholder="Enter your organization"
        context="Organization"
        readOnly={organization.id}
        value={orgQuery}
        onChange={(value) => {
          setOrgQuery(value)
          setOrganization((prev) => ({ ...prev, id: null }))
        }}
        onSelect={({ organization }) => {
          if (!organization) return
          setOrganization((prev) => ({
            ...prev,
            id: organization.id,
            name: organization.name,
            location: organization.location,
          }))
          setOrgQuery(
            `${organization.name} - ${organization.location.city} ${organization.location.country}`
          )
        }}
        openCreateModal={() => {
          setOpenModal(true)
          setDefaultQuery(orgQuery)
          setOrgQuery('')
        }}
      />
    </>
  )
}

export default OrganizationDropdown
